import Vue from 'vue';
import { JSEncrypt } from 'jsencrypt';
import { SYS_LOGIN, SYS_LOGOUT, SYS_REGISTER } from '@/api/system';
import {
  getToken, setToken, removeToken, removeXsrfCookieToken,
} from '@/util/token';
import globalConf from '@/config/globalConf';

const userStore = {
  state: {
    user: {},
    token: getToken(),
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      Vue.set(state, 'token', token);
    },
    SET_USER: (state, user) => {
      const crypt = new JSEncrypt();
      crypt.setPublicKey(globalConf.pubKey);
      const userObj = {
        id: crypt.encrypt(user.id || ''),
        name: crypt.encrypt(user.name || ''),
        token: crypt.encrypt(user.token || ''),
        type: crypt.encrypt(user.type || ''),
      };
      Vue.set(state, 'user', userObj);
    },
  },

  actions: {

    // login
    doLogin({ commit }, user) {
      return new Promise((resolve, reject) => {
        Vue.axios.jsonPost(SYS_LOGIN, user).then((response) => {
          if (response.code === 0) {
            commit('SET_USER', {
              id: response.data.id,
              name: response.data.name || '',
              token: response.data.token || '',
              type: response.data.type || '',
            });
            commit('SET_TOKEN', response.data.token);
            setToken(response.data.token);
          }
          resolve(response);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // register
    doRegister({ commit }, user) {
      return new Promise((resolve, reject) => {
        Vue.axios.jsonPost(SYS_REGISTER, user).then((response) => {
          if (response.code === 0) {
            commit('SET_USER', {
              id: response.data.id,
              name: response.data.name || '',
              token: response.data.token || '',
              type: response.data.type || '',
            });
            commit('SET_TOKEN', response.data.token);
            setToken(response.data.token);
          }
          resolve(response);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // logout
    doLogout({ commit, state }) {
      return new Promise((resolve, reject) => {
        Vue.axios.jsonPost(SYS_LOGOUT, state.token).then(() => {
          commit('SET_TOKEN', '');
          commit('SET_USER', {});
          removeToken();
          removeXsrfCookieToken();
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // timeout logout
    doTimeoutLogout({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '');
        commit('SET_USER', {});
        removeToken();
        removeXsrfCookieToken();
        resolve();
      });
    },
  },
};

export default userStore;
